//@flow
const SMALL_AREA = 500000;
const MEDIUM_AREA = 1000000;

export default function getWindowSize() {
  const windowArea = window.innerHeight * window.innerWidth;
  if (windowArea <= SMALL_AREA) {
    return 'S';
  } else if (windowArea <= MEDIUM_AREA) {
    return 'M';
  } else if (windowArea > MEDIUM_AREA) {
    return 'L';
  } else {
    return 'none';
  }
}
